import { useIntl, defineMessages } from 'react-intl';
import cx from 'classnames';
import { SidebarPortal, Icon } from '@plone/volto/components';
import { BlockDataForm } from '@plone/volto/components/manage/Form';

import type { BlockEditProps } from '@plone/types';
import ItemMenu from './menu';
import styles from '@redturtle/qubicaamf-theme/components/Blocks/OurServices/styles.module.css';
import blockIcon from '@redturtle/qubicaamf-theme/icons/cardwithimages.svg';
import type { OurServicesData } from '@redturtle/qubicaamf-theme/components/Blocks/OurServices/schema';

import config from '@plone/registry';

type OurServicesDataEditProps = BlockEditProps & {
  data: OurServicesData;
};

export default function Edit(props: OurServicesDataEditProps) {
  const { data, selected, block, onChangeBlock, blocksConfig, blocksErrors } =
    props;
  const intl = useIntl();

  const schema = blocksConfig[data['@type']].blockSchema({
    data,
    intl,
  });

  if (__SERVER__) {
    return <div />;
  }

  const Container = config.getComponent('Container').component || 'div';

  return (
    <>
      <section
        className={cx('block-ourservices', styles.block)}
        aria-label={data.title}
      >
        <Container
          className={cx('block-ourservices-container', styles.container)}
        >
          <ItemMenu
            items={data.services || []}
            title={data.title}
            isEditMode={true}
          />
        </Container>
      </section>
      {/* @ts-expect-error TODO fix */}
      <SidebarPortal selected={selected}>
        {schema && (
          <BlockDataForm
            icon={<Icon size="24px" name={blockIcon} />}
            schema={schema}
            title={schema.title}
            onChangeField={(id: string, value: unknown) => {
              onChangeBlock(block, {
                ...data,
                [id]: value,
              });
            }}
            onChangeBlock={onChangeBlock}
            formData={data}
            block={block}
            errors={blocksErrors}
          />
        )}
      </SidebarPortal>
    </>
  );
}

const messages = defineMessages({
  title: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  text: {
    id: 'Text',
    defaultMessage: 'Text',
  },
  // placeholder: {
  //   id: 'Upload a new image',
  //   defaultMessage: 'Upload a new image',
  // },
  // image: {
  //   id: 'Image',
  //   defaultMessage: 'Image',
  // },
});
